// Paths are relative to the lambdalith base path. SST mounts this service at
// /import-jobs via mapBasePath, so a full request URL is e.g.
// `${apiRootUrl}/import-jobs/{importJobId}` and lands here as `/{importJobId}`.
export const importJobsEndpoints = {
  createImportJob: { method: 'post', path: '/' },
  listImportJobs: { method: 'get', path: '/' },
  getImportJob: { method: 'get', path: '/{importJobId}' },
  listImportJobItems: { method: 'get', path: '/{importJobId}/items' },
  retryFailedItems: { method: 'post', path: '/{importJobId}/retry-failed' },
  getImportJobOutput: { method: 'get', path: '/{importJobId}/output' },
} as const
